export interface UsuarioState {
  usuario: Usuario;
  menu: any[];
  rutasPermitidas: any[];
  catExpedientes: CatExpediente[];
  loaded: boolean;
  loading: boolean;
  error: any;
}

export interface Usuario {
  idUser?: number;
  apellidoMaterno?: string;
  apellidoPaterno?: string;
  bloqueado?: boolean;
  email?: string;
  fechaCreacion?: string;
  loginName?: string;
  nombre?: string;
  empresa?: string;
  group?: number[];
  catExpedientes?: CatExpediente[];
  menu?: Menu[];
  modulo?: Modulo[];
  idEmpresa?: number;
}



export interface CatExpediente {
  descripcionTipo: string;
  idTipo: number;
  idAcl: number;
  nombreAcl: string;
  n_permiso: number;
  c_nombre: string;
}

export interface Menu {
  idMenu: number;
  titulo: string;
  ruta: string;
  icono: string;
  mostrarInicio: boolean;
  descripcion: string;
}

export interface Modulo {
  idModulo: number;
  modulo: string;
  ruta: string;
  titulo: string;
  idMenu: number;
}


// Menus TODO: CAmbiar

export const CATRUTAS = [
  {modulo: '/inicio', ruta: '/inicio', titulo: 'Inicio'},
  {modulo: '/administrador', ruta: '/administrador', titulo: 'Administrador dashboard'},
  {modulo: '/administrador', ruta: '/administrador/permisos', titulo: 'Administrador - Conjunto de permisos'},
  {modulo: '/administrador', ruta: '/administrador/grupos', titulo: 'Administrador - Grupos'},
  {modulo: '/administrador', ruta: '/administrador/tipos', titulo: 'Administrador - Tipos Documentales'},
  {modulo: '/administrador', ruta: '/administrador/usuarios', titulo: 'Administrador - Usuarios'},
  {modulo: '/administrador', ruta: '/administrador/seguridad', titulo: 'Administrador - Seguridad'},
  {
    modulo: '/administrador',
    ruta: '/administrador/tiempodocumentos',
    titulo: 'Administrador - Tiempo de Vida de Documentos'
  },
  {modulo: '/administrador', ruta: '/administrador/expedientes', titulo: 'Administrador - Expedientes'},
  {modulo: '/administrador', ruta: '/administrador/bitacoras', titulo: 'Bitacoras'},
  {modulo: '/administrador', ruta: '/administrador/reportes', titulo: 'Administrador - Reportes'},

  {modulo: '/expedientes', ruta: '/expedietes', titulo: 'Expedientes'},
];

export const MENULATERAL = [
  {
    titulo: 'Inicio',
    ruta: '/inicio',
    icono: 'home',
    mostrarInicio: false,
    descripcion: 'Pantalla de inicio'
  },
  {
    titulo: 'Administrador',
    ruta: '/administrador',
    icono: 'security',
    mostrarInicio: true,
    descripcion: 'Gestión de roles, permisos, usuarios '
  },
  {
    titulo: 'Usuarios',
    ruta: '/administrador/usuarios',
    icono: 'people',
    mostrarInicio: false,
    descripcion: 'Crea y administra usuarios'
  },
  {
    titulo: 'Empresas',
    ruta: '/empresas',
    icono: 'business',
    mostrarInicio: false,
    descripcion: 'Crea y administra empresas'
  },
  {
    titulo: 'Notificaciones',
    ruta: '/notificaciones',
    icono: 'error',
    mostrarInicio: false,
    descripcion: 'Administra notificaciones'
  },
  {
    titulo: 'Expedientes',
    ruta: '/expedientes',
    icono: 'create_new_folder',
    mostrarInicio: true,
    descripcion: 'Creación de expedientes'
  },
  {
    titulo: 'Configuración de Expedientes y Documentos',
    ruta: '/administrador/tipos',
    icono: 'inbox',
    mostrarInicio: true,
    descripcion: 'Configuración de expedientes, documentos, extracción y validaciones OCR'
  },
  {
    titulo: 'Reportes',
    ruta: '/administrador/reportes',
    icono: 'insert_chart',
    mostrarInicio: true,
    descripcion: 'Reportes'
  }

];

export interface UsuarioV2 {

}




